import { addListener, createListenerMiddleware } from '@reduxjs/toolkit';
import type { TypedAddListener, TypedStartListening } from '@reduxjs/toolkit';
import { setContext } from '@alltrails/context/slices/contextSlice';
import { setListsAndListItems } from '@alltrails/lists/slices/lists';
import getListsAndListItems from '@alltrails/lists/utils/requests';
import type { AppDispatch, RootState } from './redux';

export const listenerMiddleware = createListenerMiddleware();

export type AppStartListening = TypedStartListening<RootState, AppDispatch>;

export const startAppListening = listenerMiddleware.startListening as AppStartListening;

export const addAppListener = addListener as TypedAddListener<RootState, AppDispatch>;

const onUserLogin = async (action, listenerApi) => {
  if (action.payload.currentUser) {
    const userLists = await getListsAndListItems();
    listenerApi.dispatch(setListsAndListItems(userLists)); // dispatch lists info
  }
};

export const setupListeners = () => {
  startAppListening({ actionCreator: setContext, effect: onUserLogin });
};
